/**
 * Search Button Component
 * Toggles the search functionality
 */

import { type FC, memo } from 'react';
import Image from '../../../../../shared/components/Image';
import { useAppStore } from 'store/app/appStore';
import styles from './Actions.module.css';
import { clickCounter } from 'core/services/EventTracker';
import { testIds } from 'core/testIds';

interface SearchButtonProps {
  className?: string;
}

export const SearchButton: FC<SearchButtonProps> = memo(({ className }) => {
    const isSearchActive = useAppStore((state) => state.isSearchActive);
    const setSearchActive = useAppStore((state) => state.setSearchActive);
    const showSettingsModal = useAppStore((state) => state.showSettingsModal);
    const disabled = showSettingsModal;

    const handleClick = () => {
        if (disabled) return;

        // Track with consistent naming: click_search_{open|close}
        const action = isSearchActive ? 'close' : 'open';
        clickCounter.incrementClick(`click_search_${action}`);

        setSearchActive(!isSearchActive);
    };

    return (
        <button
            className={`${styles.searchButtonContainer} ${className ?? ''} ${isSearchActive ? styles.searchButtonActive : ''}`.trim()}
            onClick={handleClick}
            disabled={disabled}
            aria-label={isSearchActive ? 'Close search' : 'Open search'}
            aria-pressed={isSearchActive}
            aria-disabled={disabled}
            data-testid={testIds.statusBar.searchButton}
        >
            <Image src={`/ui/search`} manualAffix=".svg" alt="searchIcon" />
        </button>
    );
});

SearchButton.displayName = 'SearchButton';
